import Expression from './Expression';
import { renderer } from '../Renderer';

class AttributeExpression extends Expression {

	node:Element;
	attribute:string;
	template:string;

	constructor( node:Element, attribute:string ) {
		super();
		this.node = node;
		this.attribute = attribute;
		this.template = node.getAttribute( attribute );
	}

	update( data:any, name?:string ) {

		// handle input
		if( this.node instanceof HTMLInputElement && this.attribute == 'value' ) {
			this.node.value = renderer.render( this.template, data );
		}

		// default case set attribute
		this.node.setAttribute( this.attribute, renderer.render( this.template, data ) );
	}
}

export default AttributeExpression;
